"use strict";

const OutfallInventoryData = function () {
  let $page;

  var loadListeners = function ($parentPage) {
    $page = $parentPage;
    $page.on("2N:FormInput", `[name="asset-info[outlet-shape]"]`, onOutletShapeChange);
    $page.on("2N:FormInput", `[name="asset-info[outlet-material]"]`, onOutletMaterialChange);
  };

  var unloadListeners = function () {
    $page.off("2N:FormInput", `[name="asset-info[outlet-shape]"]`, onOutletShapeChange);
    $page.off("2N:FormInput", `[name="asset-info[outlet-material]"]`, onOutletMaterialChange);
  };

  var sortOptionsByName = function (options) {
    return options.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  };

  var getProps = function (data) {
    return {
      outletMaterialOptions: sortOptionsByName(
        OutfallInspectionConstants.getOutletMaterialOptions(),
      ),
      typeOptions: OutfallInspectionConstants.getOutletTypeOptions(),
      outletShapeOptions: OutfallInspectionConstants.getOutletShapeOptions(),
      lengthUnitOptions: OutfallInspectionConstants.lengthUnitOptions,
      elevationUnitOptions: OutfallInspectionConstants.elevationUnitOptions,
      isOutletCircular: OutfallInspectionConstants.outletShapeIsCircular(
        data.assetInfo.inventoryData?.outletShape,
      ),
      datumOptions: OutfallInventoryConstants.datumOptions,
    };
  };

  var onOutletShapeChange = function (e, outletShape) {
    const isCircular = OutfallInspectionConstants.outletShapeIsCircular(outletShape);

    $page.find(`[name="asset-info[outlet-diameter]"]`).closest("fieldset").toggle(isCircular);
    $page.find(`[name="asset-info[outlet-length]"]`).closest("fieldset").toggle(!isCircular);
    $page.find(`[name="asset-info[outlet-width]"]`).closest("fieldset").toggle(!isCircular);

    toggleOtherField(outletShape, "other-shape");
  };

  var onOutletMaterialChange = function (e, outletMaterial) {
    toggleOtherField(outletMaterial, "other-material");
  };

  var toggleOtherField = function (fieldValue, fieldToToggle) {
    $page.find(`.${fieldToToggle}`).toggleClass("hidden", fieldValue !== "other");
  };

  // Mirrors api/app/Muni/MaintenanceInspectableResource.php `getSharedFields()`
  var mapAssetToAssetInfo = function (outfall) {
    return {
      id: outfall.id,
      name: outfall.outfallName,
      assetType: "outfall",
      assetDisplayType: ToolSettings.getSetting("constants", "assetDisplayNames", "outfall"),
      isHighPriority: !!outfall.priority,
      lastInspectionDisplayDate: outfall.lastInspectionDisplayDate,
      activeMaintenanceIssues: outfall.activeMaintenanceIssues,
      inventoryData: {
        requiredFields: outfall.requiredFields,
        outletType: outfall.outletType,
        outletMaterial: outfall.outletMaterial,
        outletOtherMaterial: outfall.outletOtherMaterial,
        outletShape: outfall.outletShape,
        outletOtherShape: outfall.outletOtherShape,
        outletDiameter: outfall.outletDiameter,
        outletDiameterUnits: outfall.outletDiameterUnits,
        outletLength: outfall.outletLength,
        outletLengthUnits: outfall.outletLengthUnits,
        outletWidth: outfall.outletWidth,
        outletWidthUnits: outfall.outletWidthUnits,
        outletInvertElevation: outfall.outletInvertElevation,
        outletInvertElevationUnits: outfall.outletInvertElevationUnits,
        outletBaseElevation: outfall.outletBaseElevation,
        outletBaseElevationUnits: outfall.outletBaseElevationUnits,
        outletRimElevation: outfall.outletRimElevation,
        outletRimElevationUnits: outfall.outletRimElevationUnits,
        datum: outfall.datum,
      },
    };
  };

  return {
    loadListeners,
    unloadListeners,
    getProps,
    mapAssetToAssetInfo,
  };
};

module.exports = OutfallInventoryData();

const OutfallInspectionConstants = require("../../../outfalls/outfallInspectionConstants");
const OutfallInventoryConstants = require("../../../outfalls/outfallInventoryConstants");
const ToolSettings = require("../../../settings/toolSettings");
